/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

// 格式化时间
export function formatTime(time) {
  let dateObj;
  if (time instanceof Date) {
    dateObj = time;
  } else if (
    typeof time === "number" ||
    (typeof time === "string" && /^[0-9]+$/.test(time))
  ) {
    // 支持10位和13位timestamp
    let ts = Number(time);
    if (ts.toString().length === 10) {
      ts = ts * 1000;
    }
    dateObj = new Date(ts);
  } else {
    return "";
  }

  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  const date = dateObj.getDate();
  const hour = dateObj.getHours();
  const isAM = hour >= 0 && hour < 12;
  const minute = dateObj.getMinutes().toString().padStart(2, "0");
  const second = dateObj.getSeconds().toString().padStart(2, "0");
  return `${year}/${month}/${date} ${
    isAM ? "AM" : "PM"
  } ${hour}:${minute}:${second}`;
}
/**
 * yyyy-MM-dd hh:mm:ss
 * @param {number} ts - timestamp in milliseconds
 */
export const formatTimestamp = (ts) => {
  const date = new Date(ts);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
};

/**
 * Async delay function
 * @param {number} ms - milliseconds to delay
 * @returns {Promise<void>}
 */
export async function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Get the start of the day for a given date string
 * @param {string} dateStr - date string
 * @returns {Promise<Date>} - start of the day
 */
export async function startOfDay(dateStr) {
  const date = new Date(dateStr);
  date.setHours(0, 0, 0, 0);
  return date;
}

/** Get the end of the day for a given date string
 * @param {string} dateStr - date string
 * @returns {Promise<Date>} - end of the day
 */
export async function endOfDay(dateStr) {
  const date = new Date(dateStr);
  date.setHours(23, 59, 59, 999);
  return date;
}

/** Check if a value is a valid Date object
 * @param {any} date - value to check
 * @returns {boolean} - true if valid Date, false otherwise
 */
export function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}
